export const ApplicantEditIcon = ({ width = "48", height = "48", 
  primaryColor = 'var(--primary-bg-color)',
  secondColor = 'var(--primary-background-text-color', }) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 48 48"
    >
      <g
        id="Group_43102"
        data-name="Group 43102"
        transform="translate(-1168 -163)"
      >
        <circle
          id="Ellipse_1247"
          data-name="Ellipse 1247"
          cx="24"
          cy="24"
          r="24"
          transform="translate(1168 163)"
          fill={primaryColor}
        />
        <g
          id="Layer_92"
          data-name="Layer 92"
          transform="translate(1182.805 178)"
        >
          <path
            id="Path_24425"
            data-name="Path 24425"
            d="M20.612,2.83a2.763,2.763,0,0,0-3.933,0l-1.769,1.8,3.906,3.906,1.769-1.769a2.763,2.763,0,0,0,.028-3.933Z"
            transform="translate(-3.03 -2.008)"
            fill={secondColor}
          />
          <path
            id="Path_24426"
            data-name="Path 24426"
            d="M12.585,6.27,4.857,14a1.059,1.059,0,0,0-.175.239L2.121,19.405a.917.917,0,0,0,1.207,1.262L8.5,18.107a1.059,1.059,0,0,0,.239-.175L16.463,10.2Z"
            transform="translate(-2.013 -2.344)"
            fill={secondColor}
          />
        </g>
      </g>
    </svg>
  );
};
